module.exports = __webpack_public_path__ + "assets/img/2_718_big.31940dc9.jpg";